// extracted by mini-css-extract-plugin
module.exports = {"textField":"ForgotPassword_textField__3OZ0b","error":"ForgotPassword_error__SdtsS"};